module.exports = __webpack_public_path__ + "img/glass-half.7c16b8d6.svg";